<ng-content select="[mat-card-avatar], [matCardAvatar]"></ng-content>
<div class="mat-mdc-card-header-text">
  <ng-content
      select="mat-card-title, mat-card-subtitle,
      [mat-card-title], [mat-card-subtitle],
      [matCardTitle], [matCardSubtitle]"></ng-content>
</div>
<ng-content></ng-content>
